import { getSurfaceMcpSku } from '../api';
import { lookupSurfaceFps, tryExtractFpsFromUrl, type SurfaceFpsEntry } from './surfaceLookup';

const SKU_REGEX = /^[A-Z]{3}-[A-Z0-9]+$/;

export type SurfaceFpsSource = 'lookup' | 'url-parse' | 'sku-extract' | 'api';

export interface ResolvedSurfaceInfo extends SurfaceFpsEntry {
    source: SurfaceFpsSource;
}

function extractSkuFromUrl(url: string): string | undefined {
    const pathSegments = url.split('?')[0].split('/');
    return pathSegments.find((segment) => SKU_REGEX.test(segment));
}

export async function resolveSurfaceFps(
    surfaceUrl: string,
    signal?: AbortSignal,
): Promise<ResolvedSurfaceInfo | undefined> {
    if (!surfaceUrl) return undefined;

    const matched = lookupSurfaceFps(surfaceUrl);
    if (matched) {
        return { ...matched, source: 'lookup' };
    }

    const parsed = tryExtractFpsFromUrl(surfaceUrl);
    if (parsed) {
        return { ...parsed, source: 'url-parse' };
    }

    const extractedSku = extractSkuFromUrl(surfaceUrl);
    if (extractedSku) {
        return { id: extractedSku, version: 0, options: {}, source: 'sku-extract' };
    }

    // API fallback — fetch surface specification
    const apiData = await getSurfaceMcpSku(surfaceUrl, signal);
    if (apiData?.mcpSku) {
        return { id: apiData.mcpSku, version: 0, options: {}, source: 'api' };
    }

    return undefined;
}
